import { faFlowerTulip } from "@jewlr/pro-light-svg-icons/faFlowerTulip"
import { faGem } from "@jewlr/pro-light-svg-icons/faGem"
// import { faGift } from "@jewlr/pro-light-svg-icons/faGift"
// import { faPlane } from "@jewlr/pro-regular-svg-icons/faPlane"
// import { faBoxHeart } from "@jewlr/pro-regular-svg-icons/faBoxHeart"
import PropTypes from "prop-types"
import { connect } from "react-redux"

// import { jewlr_t } from "helpers/application"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import Shimmer from "components/ui/shimmer"
import { showHolidayShipMethodPDP } from "helpers/holiday"
import { cn } from "styles/utils"

const PromoDesktop = ({
  doubleJewlsPromo,
  doubleJewlsPromoMessage,
  holidayDelivery,
  outOfStock,
  prefStore,
  ship,
  wizardLoading,
}) => {
  if (outOfStock) return null
  if (
    !doubleJewlsPromo &&
    !sl.config.show_holiday_shipping_info_pdp &&
    (!showHolidayShipMethodPDP || holidayDelivery == false)
  ) {
    return null
  }
  if (
    wizardLoading ||
    !prefStore ||
    (showHolidayShipMethodPDP && holidayDelivery == undefined)
  ) {
    return (
      <Shimmer
        className="tablet:block mb-16 hidden"
        style={{ height: "32px" }}
      />
    )
  }

  let message = doubleJewlsPromoMessage
  if (holidayDelivery) {
    let dateMsg =
      ship.delivery_dates?.length > 0 ? ship.delivery_dates[0].date : ""
    message = (
      <>
        <strong className="font-semibold">
          Arrives by{" "}
          {sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday}
        </strong>
        {/* <strong className="font-semibold">
          {sl.config.guaranteed_holiday} {jewlr_t("terms.Shipping")} Info
        </strong> */}
        {dateMsg && (
          <>
            {" "}
            - <strong className="font-semibold">{dateMsg}</strong>
          </>
        )}
      </>
    )
  }

  if (!message) return null

  return (
    <Media
      className={cn(
        "mb-24 flex items-center justify-center rounded-sm",
        holidayDelivery ? "bg-(--light-bg-color)" : "bg-(--dark-bg-color)"
      )}
      greaterThanOrEqual="tablet"
      style={{
        "--dark-bg-color": "rgba(0,136,0,0.05)",
        "--light-bg-color": "#fcf2f2",
        height: "32px",
      }}
    >
      <FontAwesomeIcon
        className={cn(
          "text-14 mr-6",
          holidayDelivery ? "text-sale" : "text-green-darker"
        )}
        icon={holidayDelivery ? faFlowerTulip : faGem}
      />
      <p
        className={cn(
          "text-14",
          holidayDelivery ? "text-sale" : "text-green-darker"
        )}
      >
        {message}
      </p>
    </Media>
  )
}

PromoDesktop.propTypes = {
  doubleJewlsPromo: PropTypes.bool,
  doubleJewlsPromoMessage: PropTypes.string,
  holidayDelivery: PropTypes.bool,
  outOfStock: PropTypes.bool,
  prefStore: PropTypes.bool,
  ship: PropTypes.object,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    doubleJewlsPromo: state.wizard.promo_double_jewls,
    doubleJewlsPromoMessage: state.wizard.promo_double_jewls_messaging,
    holidayDelivery: state.wizard.shipping.main?.available_holiday_delivery,
    outOfStock: state.wizard.header?.product_out_of_stock,
    prefStore: state.wizardUI.prefStore,
    ship: state.wizard.shipping.main,
    wizardLoading: state.wizard.loading,
  }
}

export default connect(mapStateToProps)(PromoDesktop)
